var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75L15.75 9M15.75 9L12 5.25M15.75 9H6.75M9 12.75C9 13.4475 9 13.7963 8.92335 14.0824C8.7153 14.8588 8.10877 15.4653 7.33234 15.6734C7.04622 15.75 6.69748 15.75 6 15.75H5.625C4.57664 15.75 4.05245 15.75 3.63896 15.5787C3.08765 15.3504 2.64963 14.9123 2.42127 14.3611C2.25 13.9475 2.25 13.4233 2.25 12.375V5.625C2.25 4.57663 2.25 4.05245 2.42127 3.63896C2.64963 3.08765 3.08765 2.64963 3.63896 2.42127C4.05245 2.25 4.57664 2.25 5.625 2.25H6C6.69748 2.25 7.04622 2.25 7.33234 2.32667C8.10877 2.53472 8.7153 3.1412 8.92335 3.91765C9 4.20378 9 4.55252 9 5.25",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutDark);
export default __webpack_public_path__ + "static/media/logout-dark.98a54e8233fa664100582db5d634d665.svg";
export { ForwardRef as ReactComponent };